import React from "react";
import Assets from "Components/ListView/Assets";

const PortfolioManager = () => {
    return (
        <div>
            <Assets />
        </div>
    );
};

export default PortfolioManager;
